module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_round-cross-738c0e645ba5fb49ce941d1378970a45.svg";